module.exports = __webpack_public_path__ + "img/icon-collapse.4248de8f.svg";